import React from "react";
import { Box, Typography } from "@material-ui/core";
import textStyle from "../../../style/typography";

const CardHeader = (props) => {
  const textClasses = textStyle();

  return (
    <Box className={textClasses.headerWrap}>
      <Typography className={`${textClasses.header2} ${textClasses.semibold}`}>
        {props.title}
      </Typography>
      <Typography className={textClasses.text2}>{props.subtitle}</Typography>
    </Box>
  );
};

export default CardHeader;
